// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__EY_JR"};